// ** React Imports
import { NavLink, useLocation, useNavigate } from "react-router-dom"

// ** Third Party Components
import classnames from "classnames"

// ** Reactstrap Imports
import { Badge, UncontrolledTooltip } from "reactstrap"
import { Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
// import { setShowHideMenuData } from "../../../../../views/redux/store"
import { handleMenuCollapsed } from "../../../../../redux/layout"
import { displayMenu } from "../../../../../../src/views/redux/store"
import { isUserLoggedIn } from "../../../../../utility/Utils"

const VerticalNavMenuLink = ({ item, activeItem, menuCollapsed }) => {
  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const stores = useSelector((state) => state.commonreducerSlice)
  const isEmployee = isUserLoggedIn() && JSON.parse(isUserLoggedIn()).isEmployee
  // ** Conditional Link Tag, if item has newTab or externalLink props use <a> tag else use NavLink
  const LinkTag = item.externalLink ? "a" : NavLink
  // const [hovered, setHovered] = useState(false)

  async function displayFunction() {
    await dispatch(displayMenu(!stores?.displayMenuBool))
  }

  // ** Hooks
  const handleMenuClick = (item) => {
    if (!menuCollapsed) {
      displayFunction()
      dispatch(handleMenuCollapsed(!menuCollapsed))
    }
    if (item.navLink === '/Publications') {
      sessionStorage.removeItem('documentLibraryData')
    } else if (item.navLink === '/registry') {
      //
    } 
    // else if (item.navLink !== '/dashboard') {
    //   dispatch(setShowHideMenuData(false))
    // }
    if (!isEmployee && item.navLink === '/search') {
      if (stores.allCompanies?.length === 0 && !stores.unauthorize) {
        navigate('/Unauthorized')
      }
    }
  }

  return (
    <Fragment>
      <li
        className={classnames({
          "nav-item": !item.children,
          disabled: item.disabled,
          active: item.navLink === activeItem
        })}
        onClick={() => handleMenuClick(item)}
        id={`m${(item.title).replace(/[()\s]/g, '')}`}
        // onMouseEnter={() => setHovered(true)}
        // onMouseLeave={() => setHovered(false)}
        style={{ display: (item.show ? 'block' : 'none') }}
      >
        <LinkTag
          className={menuCollapsed ? "d-flex align-items-center menu-hover" : 'd-flex align-items-center menu-hover'}
          target={item.newTab ? "_blank" : undefined}
          /*eslint-disable */
          {...(item.externalLink === true
            ? {
              href: item.navLink || "/",
            }
            : {
              to: item.navLink || "/",
              className: ({ isActive }) => {
                if (isActive && !item.disabled) {
                  return menuCollapsed ? "d-flex align-items-center active" : 'd-flex align-items-center active';
                } else {
                  return menuCollapsed ? "d-flex align-items-center menu-hover" : 'd-flex align-items-center menu-hover';
                }
              },
            })}
          onClick={(e) => {
            if (
              item.navLink.length === 0 ||
              item.navLink === "#" ||
              item.disabled === true
            ) {
              e.preventDefault();
            }
          }}
          style={{ margin: '0 4px', textAlign: 'center' }}
        >
          <div
            className={menuCollapsed ? "twoClass" : "twoClass"}
          //className={"oneClass"}
          >
            {item.icon ? item.icon : ((item.navLink === location.pathname)) ? <img src={item.img1} alt={item.title}
              className={item.title === "Subscriptions" ? "menu_svg_icon_sub" : (item.title === "Dashboard" ? "menu_svg_icon_dash" : item.title === "Library" ? "menu_svg_icon_lib" : item.title === "Account" ? "menu_svg_icon_acc" : "menu_svg_icon")} /> : <img src={item.img} alt={item.title}
                className={item.title === "Subscriptions" ? "menu_svg_icon_sub" : (item.title === "Dashboard" ? "menu_svg_icon_dash" : item.title === "Library" ? "menu_svg_icon_lib" : item.title === "Account" ? "menu_svg_icon_acc" : "menu_svg_icon")} />} {menuCollapsed ? '' : ''}</div>
          {<span className="menu-item text-truncate" style={{ fontSize: menuCollapsed ? '12px' : '12px', marginTop: menuCollapsed ? '0px' : '0px' }}>{item.title}</span>}
          {item.badge && item.badgeText ? (
            <Badge className="ms-auto me-1" color={item.badge} pill>
              {item.badgeText}
            </Badge>
          ) : null}
        </LinkTag>
      </li>
      {/* {menuCollapsed &&
        <UncontrolledTooltip placement='right' target={`m${(item.title).replace(/[()\s]/g, '')}`}>
          {item.title}
        </UncontrolledTooltip>
      } */}
    </Fragment>
  );
};

export default VerticalNavMenuLink;
